<div class="conteudo ml-2 mr-2">
  <div class="row caixa-filtros shadow-sm">
    <div class="col-5">
      <div translate class="filtro ng-star-inserted sm-font" style="margin: 0px 10px 0px 0px;">
        {{'businessIntelligence.PCAUIO.dataInicial'}}
      </div>
      <div class="input-group input-group-sm data-fixo">
        <input class="form-control" class="form-control" placeholder="Selecio a Data de Referência" readonly
          [maxDate]="max" ngbDatepicker #dataInicialView="ngbDatepicker" [(ngModel)]="InicialData"
          [(ngModel)]="dataInicial" (click)="dataInicialView.toggle()">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" (click)="dataInicialView.toggle()" type="button">
            <em class="fa fa-calendar"></em>
          </button>
        </div>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" (click)="buscar()" type="button">
            <em class="fas fa-search"></em>
          </button>
        </div>
      </div>
    </div>
    <div class="col-5">
      <div translate class="filtro ng-star-inserted sm-font" style="margin: 0px 10px 0px 0px;">
        {{'businessIntelligence.PCAUIO.dataFinal'}}
      </div>
      <div class="input-group input-group-sm data-fixo">
        <input class="form-control" class="form-control" placeholder="Selecio a Data de Referência" readonly
          [maxDate]="max" ngbDatepicker #dataFinalView="ngbDatepicker" [(ngModel)]="FinalData" [(ngModel)]="dataFinal"
          (click)="dataFinalView.toggle()">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" (click)="dataFinalView.toggle()" type="button">
            <em class="fa fa-calendar"></em>
          </button>
        </div>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" (click)="buscar()" type="button">
            <em class="fas fa-search"></em>
          </button>
        </div>
      </div>
    </div>
    <button translate class="btn btn-primary my-2 btn-sm mt-3" type="button" (click)="buscar()">
      {{'businessIntelligence.PCAUIO.filtrar'}}
      <em class="fa fa-search"></em>
    </button>
  </div>
  <app-loading [exibir]="carregando"></app-loading>
  <div *ngIf="!carregando">
    <div class="mt-3">
      <div class="row">
        <div class="col-8 tirap button">
          <button [disabled]="!filtroconsolidado" pButton type="button"
            label="{{'commercial.commercialAtacado.titulosDinamicos.tituloPcaConsolidado' | translate}}"
            (click)="consolidado($event)" class="p-button-sm p-button-secondary p-button-outlined botaoc"></button>
          <button [disabled]="!filtropecas" pButton type="button"
            label="{{'commercial.commercialAtacado.titulosDinamicos.tituloPecas' | translate}}" (click)="pecas($event)"
            class="p-button-sm p-button-secondary p-button-outlined botaoc"></button>
          <button [disabled]="!filtroroupas" pButton type="button"
            label="{{'commercial.commercialAtacado.titulosDinamicos.tituloRoupas' | translate}}"
            (click)="roupas($event)" class="p-button-sm p-button-secondary p-button-outlined botaoc"></button>
          <button [disabled]="!filtroacessorios" pButton type="button"
            label="{{'commercial.commercialAtacado.titulosDinamicos.tituloAcessorios' | translate}}"
            (click)="acessorios($event)" class="p-button-sm p-button-secondary p-button-outlined botaoc"></button>
        </div>
        <div class="col">
          <button class="btn btn-outline-secondary btn-sm mb-1 mr-3 float-right" (click)="exportarExcel()">
            <em class="fa fa-download fa-xs"></em>
            Export Excel
          </button>
          <button translate class="btn btn-outline-secondary btn-sm mb-2 mr-1 float-right" (click)="imprimePdf()">
            <em class="fa fa-download fa-xs"></em>
            {{'businessIntelligence.PCAUIO.btnImprimir'}}
          </button>
        </div>
      </div>
    </div>
    <div id="print-section">
      <div class="container-fluid">
        <div class="content">
          <div class="legendas-caption pb-2">
            <div class="row ml-2 pt-2 pb-2">
              <div class="maior ml-2 mt-2"></div>
              <p translate class="font-sm text-muted mt-2 ml-2">
                % >
                <ng-container>
                  {{'businessIntelligence.PCAUIO.brasil'}}
                </ng-container>
              </p>
              <div class="menor ml-4 mt-2"></div>
              <p translate class="font-sm text-muted mt-2 ml-2">
                % <ng-container>
                  {{'businessIntelligence.PCAUIO.brasil'}}
                </ng-container>
              </p>
            </div>
          </div>
          <table class="table table-striped table-hover table-sm" id="excel-table">
            <thead class="thead-dark">
              <tr>
                <th [appSort]="pcauioDados" data-order="asc" data-name="codigo_dealer" class="text-center sort-click"
                  rowspan="2">
                  Dealer
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="pcauioDados" data-order="asc" data-name="nome_dealer" translate
                  class="text-center sort-click" rowspan="2">
                  {{'businessIntelligence.PCAUIO.nome'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th translate class="text-center" colspan="3">
                  {{'businessIntelligence.PCAUIO.vendaMotos'}}
                </th>
                <th translate class="text-center" colspan="3">
                  {{'businessIntelligence.PCAUIO.vendaPCA'}}
                </th>
                <th translate class="text-center" colspan="4">
                  PCAUIO
                </th>
                <th translate>
                  {{'businessIntelligence.PCAUIO.oportunidade'}}
                </th>
              </tr>
              <tr>
                <th [appSort]="pcauioDados" data-order="asc" data-name="ano_anterior_motos" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.PCAUIO.anoAnterior'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="pcauioDados" data-order="asc" data-name="ano_atual_motos" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.PCAUIO.anoAtual'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="pcauioDados" data-order="asc" data-name="percentual_motos"
                  class="text-center sort-click">
                  %
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="pcauioDados" data-order="asc" data-name="ano_anterior_pca" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.PCAUIO.anoAnterior'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="pcauioDados" data-order="asc" data-name="ano_atual_pca" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.PCAUIO.anoAtual'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="pcauioDados" data-order="asc" data-name="percentual_pca" class="text-center sort-click">
                  %
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="pcauioDados" data-order="asc" data-name="ano_anterior_pcauio" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.PCAUIO.anoAnterior'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="pcauioDados" data-order="asc" data-name="ano_atual_pcauio" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.PCAUIO.anoAtual'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="pcauioDados" data-order="asc" data-name="crescimento_pcauio" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.PCAUIO.crescimento'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="pcauioDados" data-order="asc" data-name="percentual_pcauio"
                  class="text-center sort-click">
                  %<img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
                <th [appSort]="pcauioDados" data-order="asc" data-name="venda_oportunidade" translate
                  class="text-center sort-click">
                  {{'businessIntelligence.PCAUIO.venda'}}
                  <img class="img" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="tr-body" *ngFor="let dados of pcauioDados" [ngStyle]="{backgroundColor:getColor(dados, percentual_pcauio)}">
                <td>{{dados.codigo_dealer}}</td>
                <td>{{dados.nome_dealer}}</td>
                <td>{{dados.ano_anterior_motos}}</td>
                <td>{{dados.ano_atual_motos}}</td>
                <td>{{dados.percentual_motos | percent: '1.0-0'}}</td>
                <td>{{dados.ano_anterior_pca | currency: ' '}}</td>
                <td>{{dados.ano_atual_pca | currency: ' '}}</td>
                <td>{{dados.percentual_pca | percent: '1.0-0'}}</td>
                <td>{{dados.ano_anterior_pcauio | currency: ' '}}</td>
                <td>{{dados.ano_atual_pcauio | currency: ' '}}</td>
                <td>{{dados.crescimento_pcauio | currency: ' '}}</td>
                <td>{{dados.percentual_pcauio | percent: '1.0-0'}}</td>
                <td>{{dados.venda_oportunidade | currency: ' '}}</td>
              </tr>
              <tr class="tr-footer">
                <td></td>
                <td [translate]="getTranslate(this.nome_dealer)"></td>
                <td>{{ano_anterior_motos}}</td>
                <td>{{ano_atual_motos}}</td>
                <td>{{percentual_motos | percent: '1.0-0'}}</td>
                <td>{{ano_anterior_pca | currency: ' '}}</td>
                <td>{{ano_atual_pca | currency: ' '}}</td>
                <td>{{percentual_pca | percent: '1.0-0'}}</td>
                <td>{{ano_anterior_pcauio | currency: ' '}}</td>
                <td>{{ano_atual_pcauio | currency: ' '}}</td>
                <td>{{crescimento_pcauio | currency: ' '}}</td>
                <td>{{percentual_pcauio | percent: '1.0-0'}}</td>
                <td>{{venda_oportunidade | currency: ' '}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
